import React from 'react'
import { FaAngleRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'

const SubHeader = ({message}) => {
    const navigate = useNavigate();

  return (
    <>
    <section className='px-2'>
        <div className='subheader-bg'>
        <div className='container'>

<p className='sub-heading'>{message}</p>

<p><span className='cursor-pointer' onClick={() => navigate('/')}>Home</span> <FaAngleRight /> <span>{message}</span></p>


        </div>
</div>        </section>
    </>
  )
}

export default SubHeader